import { Box, Typography, styled } from "@mui/material";

//importins icons from material ui, Icons package
import { 
    LocationOn, 
    SettingsBrightness, 
    // Public,
    Opacity,
    Brightness5,
    WbTwilight,
    Dehaze,
    Cloud

} from '@mui/icons-material';

const Row = styled(Typography)({
    padding:2,
    letterSpacing:2,
    fontSize:14,
    '& > svg': {
        marginRight:10,
        fontSize:15
    }
})

const Value = styled(Typography)({
    margin:20
})
const Information = ({ result }) => {
    return (
        result && Object.keys(result).length > 0 ? 
        <Box style={{margin:'20px 30px'}}>
            {/* <Typography>Weather on {new Date(result.sys.sunrise * 1000).toLocaleDateString()} is:</Typography> */}
            <Row><LocationOn />Location: {result.name}, {result.sys.country}</Row>
            <Row><SettingsBrightness />Temperature: {result.main.temp}</Row>
            <Row><Opacity />Humidity: {result.main.humidity}</Row>
            <Row><Brightness5 />Sunrise: {new Date(result.sys.sunrise * 1000).toLocaleTimeString()}</Row>
            <Row><WbTwilight />Sunset: {new Date(result.sys.sunset * 1000).toLocaleTimeString()}</Row>
            <Row><Dehaze />Condition: {result.weather[0].main}</Row>
            <Row><Cloud />Clouds: {result.clouds.all}%</Row>
            {/* <Typography><Public />Cordinates: {result.coord.lat}, {result.coord.lon}</Typography> */}
        </Box>
        : <Value>Please enter a city or country name to get the info.</Value>
    )
}

export default Information;